// extracted by mini-css-extract-plugin
module.exports = {"popover":"popover--ZT3b6","popoverTitle":"popoverTitle--4Yr0p","popoverContent":"popoverContent--2zPnj"};